import { REFERRER_STORAGE_KEY, TRACKING_DOMAINS } from 'define';

const url = new URL(window.location.href);
const urlReferrer = url.searchParams.get('referrer');
const documentReferrer = document.referrer;
const referrerHostname = documentReferrer ? new URL(documentReferrer).hostname : '';
const currentHostname = window.location.hostname;
const referredBySite =
  TRACKING_DOMAINS.includes(referrerHostname) ||
  referrerHostname === currentHostname ||
  referrerHostname.endsWith(`.${currentHostname}`);

if (documentReferrer && !referredBySite && !urlReferrer) {
  window.localStorage.setItem(REFERRER_STORAGE_KEY, documentReferrer);
}

if (urlReferrer) {
  window.localStorage.setItem(REFERRER_STORAGE_KEY, urlReferrer);
}
